import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts/fonts.css';  // polices de marque auto-hebergees (aucun appel a Google)
import './tokens.css';
import './design-system.css';
import './compat-aliases.css';   // Fix #1 — tokens fantômes → violet/slate
import './compat-overrides.css'; // Fix #2 — écrans hors-charte → slate/violet/Manrope
import './layout-primitives.css'; // Fix #3 — cadre de page partage (.app-page + shim)
import './polish-pass.css';      // Fix #4 — rayons, anneau de focus, echelle d'icones, .ds-card
import './print.css';            // Mode impression / export PDF (handoff ui_kits/web-app/index-print.html)
import App from './App';
import { initApiConfig } from './config/api';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Initialiser configuration API
initApiConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker : enregistré UNE fois, ici, et seulement en production
// (voir serviceWorkerRegistration.js). Il ne met en cache que l'enveloppe
// applicative du build — jamais `/api/*`. Une nouvelle version est signalée
// par PWAStatus (« Mettre à jour ») au lieu d'être servie périmée.
//
// L'ancien code désinscrivait le service worker et purgeait tous les caches à
// chaque chargement, pendant que PWAStatus réenregistrait un fichier absent
// du build : le mode hors ligne annoncé n'existait pas.
serviceWorkerRegistration.register();
